/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import HospitalBillItem from './hospital-bill-item';
import HospitalBillItemDetail from './hospital-bill-item-detail';
import HospitalBillItemUpdate from './hospital-bill-item-update';
import HospitalBillItemDeleteDialog from './hospital-bill-item-delete-dialog';

const HospitalBillItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<HospitalBillItem />} />
    <Route path="new" element={<HospitalBillItemUpdate />} />
    <Route path=":id">
      <Route index element={<HospitalBillItemDetail />} />
      <Route path="edit" element={<HospitalBillItemUpdate />} />
      <Route path="delete" element={<HospitalBillItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default HospitalBillItemRoutes;
